import React, { Component, useState, useEffect } from "react";
import axios from "axios";  // ✅ axios를 import 추가
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as sisMapActions from "store/modules/rds_sisMap";
import $ from "jquery";
import { LoadingContext } from "../../loadingContext";


import "./population.scss";

import { IoIosArrowForward } from "react-icons/io";
import { MdClose } from "react-icons/md";
import { BsPlus, BsDash } from "react-icons/bs";
import { AiOutlineUnorderedList } from "react-icons/ai";

import SisSelect from "store/sis/component/SisSelect";
import SisOverlay from "store/sis/SisOverlay";
//import { display } from "html2canvas/dist/types/css/property-descriptors/display";


/*const MyComponent = () => {
	const [tables, setTables] = useState(["census", "census_float"]); // 사용할 테이블 목록
	const [data, setData] = useState([]);
  
	// 서버에서 데이터 가져오는 함수
	const fetchData = async () => {
	  try {
		const response = await axios.post("/api/getYmd", { tables }); // API 요청
		setData(response.data);
	  } catch (error) {
		console.error("데이터 가져오기 실패:", error);
	  }
	};
	console.log(data);
}*/

class Population extends Component {
	static contextType = LoadingContext; // ✅ contextType 사용
	state = {
		title: "인구",
		activeItem: "",
		lstEmd: [],
		lstYmd: [],
		lstGb: [],
		lstSex: [],
		lstTime:[],
		source: "",
	};
	

	openSearchWrap = async (evt) => {
		
		$("#populationWrap .itemsWrap").hide();
		$("#populationWrap .searchWrap").show();
		$("#populationWrap .close").show();
		$(".source").show();
		$("#populationWrap .searchWrap").css("top","60px");

		const id = $(evt.target).closest(".item").attr("id");
		const title = $(evt.target).closest(".item").find("span").text();
		
		let source = "";
		if (id.startsWith("statistics")) {			
			source = "통계청";			
		}else if(id.startsWith("floating")) {		
			source = "시 빅데이터통합플랫폼";			
		}
		
		this.setState({
			
			activeItem: id,
			title,
			source,
		});

		if(id=="statistics"){
			await this.getYmd("census");		
			this.getGb(id);
		}else if(id=="floating"){
			await this.getYmd("census_float");		
			this.getGb(id);
		}
	};

	closeSearchWrap = () => {
		
		$("#populationWrap .searchWrap").hide();
		$("#populationWrap .itemsWrap").show();
		$("#apartModal .close").click();
		$(".tabWrap .tab.active .searchWrap .listWrap").remove();
		$("#populationWrap .close").hide();
		$(".source").hide();
		$("#populationWrap .searchWrap").css("top","");

		this.setState({
			activeItem: "",
			title: "인구",
		});

	};

	// 읍면동 불러오기
	getEmd = (value) => {
		let lstEmd = [];

		$.ajax({
			url: "/map/getEmd",
			type: "post",
			data: {
				value,
			},
			success: (res) => {
				lstEmd = res;

				this.setState({
					lstEmd: [{ emdCd: "0", emdNm: "=== 전체 ===" }, ...lstEmd],
				});
			},
		});
	};

	//년도 가져오기
	getYmd = (value) => {
		let lstYmd = [];

		$.ajax({
			url: "/map/getYmd",
			type: "post",
			async: false,
			data: {
				value,
			},
			success: (res) => {
				
				lstYmd = res;

				this.setState({
					lstYmd: [...lstYmd],
				});
			},
		});
	};

	// 년도 가져오기 (개선된 버전)
	/*getYmd = async (value) => {
		try {
			const response = await $.ajax({
				url: "/map/getYmd",
				type: "post",
				data: { value },
			});

			this.setState({ lstYmd: [...response] });
			//await new Promise((resolve) => this.setState({ lstYmd: [...response] }, resolve));

			
		} catch (error) {
			console.error("년도 데이터 가져오기 실패:", error);
		}
	};*/

	//그룹 가져오기
	getGb = (id) => {
		let lstGb = [];
		let lstSex = [];
		let lstTime = [];

		if(id==="statistics"){
			lstGb = [
				{ageCd:'AGEGNAGE00',ageNm:'0~9세'}, 
				{ageCd:'AGEGNAGE10',ageNm:'10~19세'},
				{ageCd:'AGEGNAGE20',ageNm:'20~29세'}, 
				{ageCd:'AGEGNAGE30',ageNm:'30~39세'}, 
				{ageCd:'AGEGNAGE40',ageNm:'40~49세'}, 
				{ageCd:'AGEGNAGE50',ageNm:'50~59세'}, 
				{ageCd:'AGEGNAGE60',ageNm:'60~69세'}, 
				{ageCd:'AGEGNAGE70',ageNm:'70~79세'}, 
				{ageCd:'AGEGNAGE80',ageNm:'80~89세'},
				{ageCd:'AGEGNAGE90',ageNm:'90~99세'},
				{ageCd:'AGEGNAGE99',ageNm:'100세 이상'}
			];

			lstSex = [
				{sexCd:'man',sexNm:'남자'}, 
				{sexCd:'woman', sexNm:'여자'}
			];
			this.setState({
				lstGb: [{ ageCd: "AGEGNTOTAL", ageNm: "=== 전체 ===" }, ...lstGb],
				lstSex: [{ sexCd: "0", sexNm: "=== 전체 ===" }, ...lstSex],
			});	
		}else if(id==="floating"){
			lstGb = [
				{ageCd:'AGEGNAGE00',ageNm:'0~9세'}, 
				{ageCd:'AGEGNAGE10',ageNm:'10~19세'},
				{ageCd:'AGEGNAGE20',ageNm:'20~29세'}, 
				{ageCd:'AGEGNAGE30',ageNm:'30~39세'}, 
				{ageCd:'AGEGNAGE40',ageNm:'40~49세'}, 
				{ageCd:'AGEGNAGE50',ageNm:'50~59세'}, 
				{ageCd:'AGEGNAGE60',ageNm:'60~69세'}, 
				{ageCd:'AGEGNAGE70',ageNm:'70~79세'}
			];

			lstSex = [
				{sexCd:'MAN_CNT',sexNm:'남자'}, 
				{sexCd:'WOMAN_CNT', sexNm:'여자'}
			];

			lstTime = [
				{timeCd:'AM0609',timeNm:'06~09시'}, 
				{timeCd:'AM0912', timeNm:'09~12시'},
				{timeCd:'PM1215', timeNm:'12~15시'},
				{timeCd:'PM1518', timeNm:'15~18시'},
				{timeCd:'PM1821', timeNm:'18~21시'},
				{timeCd:'PM2100', timeNm:'20~00시'},
				{timeCd:'AM0006', timeNm:'00~06시'}
			];
			this.setState({
				lstGb: [{ ageCd: "0", ageNm: "=== 전체 ===" }, ...lstGb],
				lstSex: [{ sexCd: "0", sexNm: "=== 전체 ===" }, ...lstSex],
				lstTime: [{ timeCd: "0", timeNm: "=== 전체 ===" }, ...lstTime],
			});	
		}
			
	};

	// 오버레이 클릭 이벤트(모달)
	_overlayClickEvent = (ele, id, activeItem, noProps = false) => {
		const { actions, layout, sis } = this.props;
		if(ele.geometry){
			ele.geom = ele.geometry;
		}
		activeItem = id.split("_")[1];
		

		// 특정 패턴으로 시작하는 모든 요소 선택
		document.querySelectorAll(`[id^='${id}_']`).forEach(el => el.remove());
		id = id + "_"+ ele.gid;

		
		let overlayElement;
		let col;

		 if (activeItem === "statistics") {
			overlayElement = (
				<>
					<div
						className="sisOverlayClose"
						onClick={() => {
							$(`#${id}`).remove();
						}}
					>
						<MdClose size="25px" />
					</div>
					<span className="populationTitle">{ele.hdong}</span>
					<table>
						<caption>인구</caption>
						<tbody>
							<tr>
								<th>전체인구</th>
								<td>{ele.ageCnt != null && !isNaN(Number(ele.ageCnt)) ? Number(ele.ageCnt).toLocaleString() : "-"}명</td>
							</tr>
							<tr>
								<th>남자인구</th>
								<td>{ele.manCnt != null && !isNaN(Number(ele.manCnt)) ? Number(ele.manCnt).toLocaleString() : "-"}명</td>
							</tr>
							<tr>
								<th>여자인구</th>
								<td>{ele.womanCnt != null && !isNaN(Number(ele.womanCnt)) ? Number(ele.womanCnt).toLocaleString() : "-"}명</td>
							</tr>
							<tr>
								<th>연령별</th>
								<td>{ele.age  ? ele.age : "-"}</td>
							</tr>
						</tbody>
					</table>
					
					{/*<span className="populationTel">전체인구 : {ele.ageCnt.toLocaleString() ? ele.ageCnt.toLocaleString() : "-"}</span>
					<span >남자인구 : {ele.manCnt.toLocaleString() ? ele.manCnt.toLocaleString() : "-"}</span>
					<span >여자인구 : {ele.womanCnt.toLocaleString() ? ele.womanCnt.toLocaleString() : "-"}</span>*/}

					
				</>
			);
		} else if(activeItem==="floating"){
			overlayElement = (
				<>
					<div
						className="sisOverlayClose"
						onClick={() => {
							$(`#${id}`).remove();
						}}
					>
						<MdClose size="25px" />
					</div>
					<span className="populationTitle">{ele.hdong}</span>
					<table>
						<caption>인구추이</caption>
						<tbody>
							<tr>
								<th>년도</th>
								<td>{ele.stdYmd ? ele.stdYmd : "-"}</td>
							</tr>
							<tr>
								<th>인구</th>
								<td>{ele.totalCnt != null && !isNaN(Number(ele.totalCnt)) ? Number(ele.totalCnt).toLocaleString() : "-"}명</td>
							</tr>
							<tr>
								<th>성별</th>
								<td>{ele.sex  ? ele.sex  : "-" }</td>
							</tr>
							<tr>
								<th>연령별</th>
								<td>{ele.guBun  ? ele.guBun  : "-" }</td>
							</tr>
							<tr>
								<th>시간</th>
								<td>{ele.stdTime  ? ele.stdTime  : "-" }</td>
							</tr>
						</tbody>
					</table>
					{/*<span className="populationTitle">{ele.hdong}</span>
					<span className="populationTel">년도 : {ele.stdYmd ? ele.stdYmd : "-"}</span>
					<span>인구 : {ele.totalCnt.toLocaleString() ? ele.totalCnt.toLocaleString() : "-"}</span>*/}
				</>
			);
		}

		let overlay = sis.sisMap.map.getOverlayById("overlaySelector");
		sis.sisMap.map.removeOverlay(overlay);

		actions.addResultOverlay({
			element: overlayElement,
			data: ele,
			id,
			className: "removeOverlayWrap",
			isTop: true,
			noProps,
		});

		$(".sisOverlay").css("width","200px");
	};

	// 오버레이 클릭 이벤트(겹치는거 확인)
	overlayClickEvent = (ele, evt, overlay) => {
		const { actions, layout, sis } = this.props;
		

		let col = "";
		const activeItem = $(evt.target).closest(".sisOverlayWrap").find("span:first").attr("class");
		const id = `population_${activeItem}_removeOverlay`;
		$(`#${id}`).remove();

		let existOverlay = sis.sisMap.map.getOverlayById(id);
		if (existOverlay) sis.sisMap.map.removeOverlay(existOverlay);

		/*if (activeItem === "museum") col = "fcltyNm";
		else if (activeItem === "sightseeing") col = "trrsrtNm";
		else*/if (activeItem === "statistics") col = "hdong";
		else col = "infDskNm";

		const arrOverlays = [];
		const pos = overlay.getPosition();
		const interval = 1;
		let xInterval = 0;
		let yInterval = 0;
		const overlays = sis.sisMap.map.getOverlays().getArray();

		$.each(overlays, (idx, item) => {
			let targetPos = item.getPosition();

			if (targetPos) {
				targetPos = targetPos;

				xInterval = Math.abs(pos[0] - targetPos[0]);
				yInterval = Math.abs(pos[1] - targetPos[1]);

				if (xInterval <= interval && yInterval <= interval) {
					arrOverlays.push(item);
				}
			}
		});

		if (arrOverlays.length > 1) {
			// if (true) {
			// 오버레이 생성
			const overlayElement = document.createElement("div");
			document.body.appendChild(overlayElement);
			overlayElement.className = "overlaySelector";
			overlayElement.id = "overlaySelector";

			let overlay = sis.sisMap.map.getOverlayById("overlaySelector");

			if (overlay) sis.sisMap.map.removeOverlay(overlay);
			overlay = new SisOverlay(`#overlaySelector`, sis.sisMap.map, "bottom-center", [0, 0]);
			overlay.setPosition(pos);
			$(overlayElement).parent().css("z-index", 9999);

			arrOverlays.forEach((item) => {
				const props = item.getProperties();

				if (props[col]) {
					const element = document.createElement("div");
					element.innerText = props[col];
					$(overlayElement).append(element);

					$(element).on("click", () => {
						this._overlayClickEvent(props, id, activeItem, true);
						sis.sisMap.map.removeOverlay(overlay);
					});
				}

				// $(overlayElement).append(`<div>${props.buildNm}</div>`);
			});
		} else {
			this._overlayClickEvent(ele, id, activeItem);
		}

		return;
	};

	// 오버레이 생성
	createOverlay = (data, id) => {
		const { actions } = this.props;
		const { activeItem } = this.state;

		$(".tabWrap .tab.active .searchWrap .listWrap").remove();
		$(".tabWrap .tab.active .searchWrap").append("<div class='listWrap'><span class='cnt'>검색결과 <a>" + data.length.toLocaleString() + "</a>건</span></div>");

		data.forEach((ele, idx) => {
			let overlayElement;

			/*if (activeItem === "museum") {
				overlayElement = (
					<>
						<span className={activeItem}>{ele.fcltyNm}</span>
					</>
				);
				$(".tabWrap .tab.active .searchWrap .listWrap").append(`<span class=lst_${id}_${ele.gid}>${ele.fcltyNm}</span>`);
			} else if (activeItem === "sightseeing") {
				overlayElement = (
					<>
						<span className={activeItem}>{ele.trrsrtNm}</span>
					</>
				);
				$(".tabWrap .tab.active .searchWrap .listWrap").append(`<span class=lst_${id}_${ele.gid}>${ele.trrsrtNm}</span>`);
			} else */if (activeItem === "statistics") {
				overlayElement = (
					<>
						<span className={activeItem}>{ele.hdong}</span>
					</>
				);
				//$(".tabWrap .tab.active .searchWrap .listWrap").append(`<span class=lst_${id}_${ele.gid}>${ele.hdong}</span>`);
			}  else {
				overlayElement = (
					<>
						<span className={activeItem}>{ele.cultNam}</span>
					</>
				);
				//$(".tabWrap .tab.active .searchWrap .listWrap").append(`<span class=lst_${id}_${ele.gid}>${ele.cultNam}</span>`);
			}

			// $(`.lst_${id}_${ele.gid}`).on("click", () => {
			// 	$(`#${id}_${ele.gid}`)[0].click();

			// 	const feature = this.props.sis.sisLayer.createFeatureByWKT(ele.geom);
			// 	feature.getGeometry().transform("EPSG:5186", "EPSG:5181");
			// 	this.props.sis.sisMap.view.fit(feature.getGeometry().getExtent());
			// 	this.props.sis.sisMap.view.setZoom(8);
			// });

			actions.addResultOverlay({
				element: overlayElement,
				data: ele,
				id: `${id}`,
				className: "populationOverlayWrap",
				onClick: this.overlayClickEvent,
				minZoom: 6,
				maxZoom: 10,
			});
		});
		if(activeItem === "statistics"){
			$(".tabWrap .tab.active .searchWrap .listWrap").css("top","275px");
		}
		//const { setLoading } = this.context; // ✅ context에서 setLoading 가져오기
    	
	};

	// 최대값 & 최솟값 구하기
	getMinMaxAgeCnt = (data, activeItem) => {
		if (!data || data.length === 0) {
			return { max: -Infinity, min: Infinity }; // 빈 데이터 처리
		}

		let valueExtractor;

		if (activeItem.startsWith("statistics")) {
			valueExtractor = (item) => {
				switch (data.sex) {
					case "man": return item.manCnt;
					case "woman": return item.womanCnt;
					default: return item.ageCnt; // 기본값 "0"
				}
			};
		} else if (activeItem.startsWith("floating")) {
			valueExtractor = (item) => item.totalCnt;
		} else {
			return { max: -Infinity, min: Infinity }; // 처리할 필요 없는 경우 기본값 반환
		}

		return data.reduce(
			(acc, item) => {
				const value = valueExtractor(item);
				acc.max = Math.max(acc.max, value);
				acc.min = Math.min(acc.min, value);
				return acc;
			},
			{ max: -Infinity, min: Infinity }
		);
	};

	// 트리 범례 생성
	createTreeLeend = (props) => {
		let maxAgeCnt = -Infinity;
		let minAgeCnt = Infinity;
        let data = props.data;
		
		let activeItem = props.id;
		if (data.length > 0) {
			({ max: maxAgeCnt, min: minAgeCnt } = this.getMinMaxAgeCnt(data, activeItem));
		}
		let cleanedItem = activeItem.replace(/_/g, "");

		if(cleanedItem.startsWith("statistics")||cleanedItem.startsWith("floating")){
			const colors = [
				{ color: "rgba(255, 255, 178, 0.8)", label: "1단계" }, // 밝은 노란색
				{ color: "rgba(254, 204, 92, 0.8)", label: "2단계" },  // 연한 주황색
				{ color: "rgba(253, 141, 60, 0.8)", label: "3단계" },  // 주황색
				{ color: "rgba(240, 59, 32, 0.8)", label: "4단계" },   // 빨간색
				{ color: "rgba(189, 0, 38, 0.8)", label: "5단계" }    // 진한 빨간색
			  ];
			
			  const range = maxAgeCnt - minAgeCnt;
			  const step = range / 5;

			return (
				<>
					<div className="legendWrap">
						<div
							className="legendToggle"
							onClick={(e) => {
								$(e.target).closest(".legendToggle").find(".legendVisible").toggle();
								$(e.target).closest(".legendWrap").find(".legendContents").slideToggle("fast");
							}}
						>
							<BsPlus className="legendVisible hide" size="18px" />
							<BsDash className="legendVisible" size="18px" />
						</div>
	
						<span className="legendTitle">
							<AiOutlineUnorderedList size="15px" />
							범례
						</span>
	
						<div className="legendContents">
						{colors.map((item, index) => (
							<div key={index} className="tag legendItem">
							<div className="tag colorBox" style={{ backgroundColor: item.color }}></div>
							<span className="tag legendSpan">{`${Math.round(minAgeCnt + step * index).toLocaleString()} ~ ${Math.round(minAgeCnt + step * (index + 1)).toLocaleString()}`}</span>
							</div>
						))}
						</div>
					</div>
				</>
			);
		};
	}

	// 검색
	search = async  (evt, id) => {
		
		const { setLoading } = this.context; // ✅ context에서 setLoading 가져오기
    	setLoading(true);
		$(".layerOpen").css("display","block");

		let { activeItem } = this.state;
		const { actions, sis } = this.props;

		let stdYmd = document.querySelector("select#selectLivingStdYmd");
		// stdYmd 값을 select에서 직접 가져오기
		if (stdYmd) {
			stdYmd = stdYmd.value;
		} else {
			stdYmd = null;  // 요소가 없으면 기본값 null 설정
		}

		// 기준년도 값이 없으면 1초 대기 후 실행
		const waitForStdYmd = () => {
			return new Promise(resolve => {
			  if (!stdYmd || stdYmd.trim() === "") {
				//console.log("기준년도 값이 없습니다. 1초 대기 중...");
				// 1초 대기 후, resolve를 호출하여 대기 끝냄
				setTimeout(() => {
				  resolve(); // Promise를 해결하여 대기 종료
				}, 2000);
			  } else {
				//console.log("기준년도 값이 있습니다.");
				resolve(); // 바로 resolve하여 대기 없이 진행
			  }
			});
		  };
		
		  // 비동기적으로 처리할 함수
		  await waitForStdYmd(); // 기준년도 값이 없으면 1초 기다리기
		
		//let index = 1;
		//let baseId = "population_" ;
		//let lyr = this.props.sis.sisLayer.getLayerByID(baseId+activeItem);

		//while (lyr) {
		//	activeItem = activeItem + "_" + index;
		//	index++;
		//	lyr = this.props.sis.sisLayer.getLayerByID(baseId+activeItem);
		//}
		let title = "";
		let source = "";
		let data = [];
		let guBun = "0";
		let stdTime = "0";
		let sex = "0";
		let sggCode,emdCode,layerName = "";
		let cleanedItem = activeItem.replace(/_/g, "");
		sggCode = $("select#selectPopulationSgg").val() || "0";
		emdCode = $("select#selectPopulationEmd").val() || "0";
		if(cleanedItem.startsWith("statistics")){
			stdYmd = document.querySelector("select#selectPopulationStdYmd").value || $("select#selectPopulationStdYmd option:first").val() || "0";
    		guBun = document.querySelector("select#selectPopulationAge").value || "AGEGNTOTAL";
			sex = $("select#selectPopulationSex").val() || "0";
			layerName = `population_${activeItem}_${sggCode}_${emdCode}_${stdYmd}_${guBun}_${sex}`;

		}else if(cleanedItem.startsWith("floating")){
			stdYmd = document.querySelector("select#selectPopulationStdYmd").value ||$("select#selectPopulationStdYmd option:first").val() || "0";
			sex = $("select#selectPopulationSex").val() || "0";
    		guBun = document.querySelector("select#selectPopulationAge").value || "0";
			stdTime = document.querySelector("select#selectPopulationTime").value || "0";
			
			layerName = `population_${activeItem}_${sggCode}_${emdCode}_${stdYmd}_${sex}_${guBun}_${stdTime}`;
		}

		let params = {
			sggCode: sggCode,
			emdCode: emdCode,
			stdYmd: stdYmd,
			guBun: guBun,
			stdTime: stdTime,
			sex: sex,
		};
		let color = "#ff0000";
		let url = "";
		let legend = "";
		 if (cleanedItem.startsWith("statistics")) {
			title = "인구통계";
			color = "#ec407a";
			url = "/map/selectCensus";
			source = "통계청";
			
		}else if(cleanedItem.startsWith("floating")) {
			title = "유동인구 정보";
			color = "#ec407a";
			url = "/map/selectFloating";
			source = "통계청";
			
		}

		$.ajax({
			url,
			type: "post",
			data: params,
			success: (res) => {
				data = res.items ? res.items : res;

				if (data.length === 0) {
					alert("검색결과가 없습니다.");
					setLoading(false);
					return;
				}
				let type = "point";
				if (cleanedItem.startsWith("statistics")){
					type = "polygon";
					data.sex = $("select#selectPopulationSex").val() || "0";
					data.age = $("select#selectPopulationAge option:selected").text().replace(/=/g, "");
					legend = this.createTreeLeend({
						data,
						id: activeItem,
					});
				}else if(cleanedItem.startsWith("floating")){
					type = "polygon";
					data.sex = $("select#selectPopulationSex option:selected").text().replace(/=/g, "");
    				data.guBun = $("select#selectPopulationAge option:selected").text().replace(/=/g, "");
					data.stdTime = $("select#selectPopulationTime option:selected").text().replace(/=/g, "");
					legend = this.createTreeLeend({
						data,
						id: activeItem,
					});
				}
				
				if (res.wkt) {
					const feature = sis.sisLayer.createFeatureByWKT(res.wkt);
					feature.getGeometry().transform("EPSG:5186", "EPSG:5181");
					const extent = feature.getGeometry().getExtent();

					sis.sisMap.view.fit(extent);
				}

				const lyr = sis.sisLayer.getLayerById(layerName);

				if (lyr) {
					actions.deleteResult({
						id: layerName,
						refresh: true,
					});
				}

				// 트리아이템 생성
				
				actions.addResultItem({
					data: legend,
					id: layerName,
					title,
					closeEvent: actions.deleteResult,
					checkboxEvent: actions.resultCheckboxHandler,
				});
				
				
				
				// 레이어 생성
				/*actions.addResultLayer({
					data,
					id: `population_${activeItem}`,
					type: type,
					color,
				}).then(() => {
					// ✅ 레이어가 생성 완료된 후 로딩 종료
					setLoading(false);
				  })
				  .catch((error) => {
					console.error("레이어 생성 중 오류 발생:", error);
					setLoading(false); // ✅ 오류 발생 시에도 로딩 종료
				  });;*/
				  actions.addResultLayer(
					{
					  data,
					  id: layerName,
					  type: type,
					  color,
					  callback: () => {
						requestAnimationFrame(() => {
							setLoading(false); 		
						  });
					  	},
						clickCallback: (featureProps) => {
							console.log("클릭된 Feature 데이터:", featureProps);
							//alert(`선택한 데이터: ${featureProps.manCnt ?? featureProps.womanCnt ?? featureProps.totalCnt ?? "정보 없음"}`);
							const currentLayerId = this.getLatestLayerId();
							this._overlayClickEvent(featureProps, featureProps.id,currentLayerId)
						}
					}
				  );

			
				
				// 오버레이 생성
				//this.createOverlay(data, layerName);
			},
		});
		//setTimeout(() => {
		//	setLoading(false); // ✅ 2초 후 로딩 종료 (예제)
		 // }, 2000);
		//setLoading(false); // 예제: 로딩 상태 변경
	};

	getLatestLayerId() {
		// 현재 등록된 레이어 중 가장 마지막 id 가져오기
		return this.state.activeItem;
	  }

	render() {
		const { activeItem } = this.state;
		const { lstSgg } = this.props.sis;
		
		let searchElement;
		let cleanedItem = activeItem.replace(/_/g, "");
		if (cleanedItem.startsWith("floating")) {
			searchElement = (
				<>
					<div className="inputWrap">
						<span className="selectTitle">기준년도</span>
						<SisSelect
							id="selectPopulationStdYmd"
							ref={(ref) => (this.selectwelfareStdYmd = ref)}
							className="select"
							mapping={{
								key: "stdYmd",
								text: "stdName",
							}}
							items={this.state.lstYmd}
						/>
					</div>
					<div className="inputWrap">
						<span className="selectTitle">구명</span>
						<SisSelect
							id="selectPopulationSgg"
							className="select"
							items={lstSgg}
							mapping={{
								key: "sggCd",
								text: "sggNm",
							}}
						/>
					</div>
					<div className="inputWrap">
						<span className="selectTitle">성별</span>
						<SisSelect
							id="selectPopulationSex"
							className="select"
							mapping={{
								key: "sexCd",
								text: "sexNm",
							}}
							items={this.state.lstSex}
						/>
					</div>
					<div className="inputWrap">
						<span className="selectTitle">연령별</span>
						<SisSelect
							id="selectPopulationAge"
							className="select"
							mapping={{
								key: "ageCd",
								text: "ageNm",
							}}
							items={this.state.lstGb}
						/>
					</div>
					<div className="inputWrap">
						<span className="selectTitle">시간</span>
						<SisSelect
							id="selectPopulationTime"
							className="select"
							mapping={{
								key: "timeCd",
								text: "timeNm",
							}}
							items={this.state.lstTime}
						/>
					</div>
				

					<div className="btnWrap">
						<button id="btnSearch" onClick={(evt) => this.search(evt, activeItem)}>
							검색
						</button>
					</div>
				</>
			);
		}
		else if (cleanedItem.startsWith("statistics")) {
			searchElement = (
				<>
					<div className="inputWrap">
						<span className="selectTitle">기준년도</span>
						<SisSelect
							id="selectPopulationStdYmd"
							ref={(ref) => (this.selectwelfareStdYmd = ref)}
							className="select"
							mapping={{
								key: "stdYmd",
								text: "stdName",
							}}
							items={this.state.lstYmd}
						/>
					</div>
					<div className="inputWrap">
						<span className="selectTitle">구명</span>
						<SisSelect
							id="selectPopulationSgg"
							className="select"
							items={lstSgg}
							mapping={{
								key: "sggCd",
								text: "sggNm",
							}}
							
						/>
					</div>
					<div className="inputWrap">
						<span className="selectTitle">성별</span>
						<SisSelect
							id="selectPopulationSex"
							className="select"
							mapping={{
								key: "sexCd",
								text: "sexNm",
							}}
							items={this.state.lstSex}
						/>
					</div>
					<div className="inputWrap">
						<span className="selectTitle">연령별</span>
						<SisSelect
							id="selectPopulationAge"
							className="select"
							mapping={{
								key: "ageCd",
								text: "ageNm",
							}}
							items={this.state.lstGb}
						/>
					</div>
					

					<div className="btnWrap">
						<button id="btnSearch" onClick={(evt) => this.search(evt, activeItem)}>
							검색
						</button>
					</div>
				</>
			);
		}

		return (
			<div id="populationWrap" className="contentsWrap">
				<div className="title">
					<span>{this.state.title}</span>
					<div className="close" onClick={this.closeSearchWrap}>
						<MdClose />
					</div>
				</div>
				<div className="source" style={{display:"none"}}>
					<span className="origin_tit">출처</span>
					<span className="origin_stxt">{this.state.source}</span>
				</div>
				<div className="itemsWrap">

					<div id="statistics" className="item" onClick={this.openSearchWrap}>
						<span>인구 통계</span>
						<IoIosArrowForward className="arrow" />
					</div>
					<div id="floating" className="item" onClick={this.openSearchWrap}>
						<span>유동인구 정보</span>
						<IoIosArrowForward className="arrow" />
					</div>
				</div>

				<div className="searchWrap">{searchElement}</div>
				
			</div>
			
		);
	}
}

export default connect(
	(state) => ({
		sis: state.sisMap,
	}),
	(dispatch) => ({
		actions: bindActionCreators(sisMapActions, dispatch),
	})
)(Population);
